import { Box } from '@wix/design-system';
import {
  StudioCta,
  useAnonymous,
  useIsStudioNewUi,
} from '@wix/package-picker-shared-studio';
import classNames from 'classnames';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { PageTitle } from '../PageTitle/PageTitle';
import s from './Header.scss';
import { PromotionalMessage } from './PreHeader/PromotionalMessage';
import { Subtitle } from './Subtitle';

export const Header = () => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();

  const { isAnonymous, signInRedirectionLink } = useAnonymous();
  const isStudioNewUi = useIsStudioNewUi();

  const handleAnonymousCtaClick = () => {
    StudioPackagePickerModule.internals.bi.onAnonymousCtaClick?.({
      targetUrl: signInRedirectionLink,
      origin: 'top',
    });
    window.open(signInRedirectionLink, '_self');
  };

  return (
    <Box
      direction="vertical"
      width="100%"
      gap={isStudioNewUi ? '16px' : 'SP3'}
      marginTop={isAnonymous ? 'SP3' : '0'}
    >
      {!isStudioNewUi && <PromotionalMessage />}
      <PageTitle />
      <Box direction="horizontal" align="center">
        <Subtitle />
      </Box>
      {isAnonymous && (
        <Box
          margin="SP2 auto 0 auto"
          className={classNames(s.selectButtonWrapper, s.filled)}
        >
          <StudioCta filled onClick={handleAnonymousCtaClick} size="medium">
            {t('studio_package_picker.anon.CTA')}
          </StudioCta>
        </Box>
      )}
    </Box>
  );
};
